<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path:'/'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
    <el-row :gutter="20">
      <el-text>昵称：</el-text>
      <el-col :span="4">
        <el-input
          placeholder="请输入内容"       
          clearable
          v-model="txt1">
          </el-input>  
      </el-col>
      <el-row>
        <el-button @click="searchPage" :icon="search" circle>
          <el-icon><Search /></el-icon>
        </el-button>
      </el-row>
    </el-row>
    <!-- 新增、批量删除按钮 -->
    <el-row class="bt">
      <el-button type="primary" @click="addClick">+新增</el-button>
    </el-row>
    <!-- 管理列表 -->
    <el-table :data="tableData" style="width:100%">
      <el-table-column prop="wechatNum" label="微信号" />
      <el-table-column prop="nickname" label="昵称" />
      <el-table-column prop="realName" label="真实姓名" />
      <el-table-column label="性别">
        <template #default="scope">
          <span v-if="scope.row.sex=='1'">男</span>
          <span v-if="scope.row.sex=='0'">女</span>
          <span v-if="scope.row.sex=='2'">保密</span>
        </template>
      </el-table-column>
      <el-table-column label="用户头像">
        <template #default="scope">
          <img :src="scope.row.face" style="height: 50px; width:50px" v-if="scope.row.face" />
        </template>
      </el-table-column>
      <el-table-column prop="birthday" label="生日" />
      <el-table-column label="地区">
        <template #default="scope">
          {{ scope.row.province }} / {{ scope.row.city }} 
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" label="注册时间" />
      <el-table-column label="会员等级">
        <template #default="scope">
          {{ scope.row.vipLevelName?"VIP"+scope.row.vipLevelName:"" }}
        </template>
      </el-table-column>
      <el-table-column prop="vipOvertime" label="会员到期时间" />
      <el-table-column prop="schoolName" label="学校" />
      <el-table-column prop="coin" label="邮票" />
      <el-table-column prop="reward" label="佣金" />
      <el-table-column prop="recommendUserId" label="推荐人" />

      <el-table-column fixed="right" label="操作" width="150" v-if="false">
        <template #default="scope">
          <el-button link type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button link type="primary" size="small" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="kh-page">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100, 500]"
            :page-size="currentPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </div>
  </el-card>
</div>
</template>

  
<script>

  export default{
    data(){
      return {
        tableData : [],
        txt1: '',
        currentPage: 1,
        currentPageSize: 10,
        totalCount: 0
      }
    },
    mounted:function(){
      this.getPage()
    },
    methods:{
      //添加
      addClick(){
        this.$router.push("/Admin/UsersEdit")
      },
      getPage(){
        var ths = this
        var queryBO = {
          name: this.txt1,
          page: this.currentPage,
          pageSize: this.currentPageSize,
          sortField: ''
        }
        ths.$post('/Users/queryPage',queryBO)
        .then(function (res) { 
            if(res.success){
              ths.tableData = res.data.rows
              ths.totalCount = res.data.records
            }
        })
        .catch(function (err) {
          console.log(err)
        })    
      },
      handleEdit(row){
        this.$router.push("/Admin/UsersEdit?id="+row.id)
      },
      handleDelete(row){
        if(confirm("确定要删除吗？")){
          var ths = this
          ths.$get('/Users/delete?id='+row.id)
          .then(function (res) { 
              alert(res.msg)
              if(res.success){
                ths.getPage()
              }
          })
          .catch(function (err) {
            console.log(err)
          })    
        }
      },
      handleSizeChange(val) {
        this.currentPageSize = val
        this.getPage()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPage()
      },
      searchPage(){
        this.currentPage = 1
        this.getPage()
      }
    }
  }

</script>

<style>
.bt{
  padding:20px 0;
}
</style>